import { TrainingProject, TrainingProjectFormData } from "../types"
import { ID, PaginationResult } from "@/types/common"
import { createCrudApi } from "@/utils/apiFactory"

const baseApi = createCrudApi<
  TrainingProject,
  TrainingProjectFormData,
  TrainingProjectFormData
>("/training-projects")

// 训练项目API
const trainingProjectApi = {
  // 查询所有
  async getList(
    domainLv2Id?: ID
  ): Promise<PaginationResult<TrainingProject>> {
    return baseApi.list({ domainLv2Id })
  },

  // ID查询
  async getById(id: ID): Promise<TrainingProject | null> {
    return baseApi.getById(id)
  },

  // 创建
  async create(data: TrainingProjectFormData): Promise<void> {
    const payload = {
      domainLv2Id: data.domainLv2Id,
      note: data.note || "",
      ...(data.names?.length ? { names: data.names } : { name: data.name }),
    }
    await baseApi.create(payload)
  },

  // 更新
  async update(id: ID, data: TrainingProjectFormData): Promise<void> {
    const payload = {
      name: data.name,
      domainLv2Id: data.domainLv2Id,
      note: data.note || "",
    }
    await baseApi.update(id, payload)
  },

  // 删除（统一使用数组参数，支持单个和批量）
  async delete(ids: ID[]): Promise<void> {
    await baseApi.delete(ids)
  },
}

export default trainingProjectApi
